export default __webpack_public_path__ + "static/lidar-wide-f788d9e66777108edd8fbf8f386f92ac.jpg";